var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",attrs:{"required":_vm.required},domProps:{"value":_vm.value},on:{"input":e => _vm.$emit('input', e.target.value)}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":option}},[_vm._v("\n        "+_vm._s(option)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }